
import { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getBlobName, getTokenAndFetchHeaders, getFileIcon, getFileName } from '../../utils';
import { apiRequest } from '../../utils/authConfig';
import { useMsal, account } from '../../utils/authContext';
import ReactGA from 'react-ga';
const OrderFileCard = (props: any) => {
    const { getToken } = useMsal();
    const [downloading, setDownloading] = useState(false);
    const url = props.item;
    const icon = getFileIcon(url);

    const handleDownload = async () => {
        setDownloading(true);
        const api = process.env['REACT_APP_BACKEND_URL'];
        const args = { ...apiRequest, account };
        const apiKey = process.env.REACT_APP_BACKEND_KEY ? process.env.REACT_APP_BACKEND_KEY : '';
        const headers = await getTokenAndFetchHeaders(getToken, args, apiKey);
        const parts = url.split('/');
        const orderNumber = parts[parts.length - 2];
        const blobName = getBlobName(url);
        const blobPath = `${orderNumber}/${blobName}`;
        try {
            fetch(`${api}/order/file/download/?blobName=${encodeURIComponent(blobPath)}`, {
                method: 'Get',
                headers,
            })
                .then(async res => {
                    const token = await res.text();
                    setDownloading(false);
                    const filePath = `${url}?${token}`;
                    ReactGA.event({
                        category: "File",
                        action: "download",
                        label: "File Download",
                        dimension1: filePath
                    });
                    window.location.href = filePath;
                },
                    (error) => {
                        console.error(error);
                        setDownloading(false);
                    });
        } catch (err: any) {
            console.error(err);
        }
    }
    return <Card className="mt-4">
        <FontAwesomeIcon className='d-print-none' style={{ display: "block", margin: "1rem auto 0" }} size="2x" icon={icon} />
        <Card.Body>
            <Card.Text className="text-center">File Name: {getFileName(url)}</Card.Text>
            <Button disabled={downloading} className="float-end d-print-none" variant="outline-secondary" size="sm" onClick={handleDownload}>{downloading ? 'Downloading ...' : 'Download'}</Button>
        </Card.Body>
    </Card>
}
export default OrderFileCard;
